"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import clsx from "clsx";
import { useTranslations } from "next-intl";

/**
 * ShowAllButton Component
 * "Tümünü Göster" / "Tümünü Gösterme" butonu
 * ExpandableTextSection'daki buton tasarımına benzer
 */
export default function ShowAllButton({
  isExpanded,
  onToggle,
  className = "",
  showText,
  hideText,
}) {
  const t = useTranslations("common");
  const displayShowText = showText ?? t("showAllText");
  const displayHideText = hideText ?? t("hideAllText");

  return (
    <div className={clsx("flex justify-center mt-6", className)}>
      <button
        onClick={onToggle}
        className="text-primary flex cursor-pointer items-center justify-center gap-2 text-lg font-medium"
      >
        <span>{!isExpanded ? displayShowText : displayHideText}</span>
        <div className="flex h-full items-center justify-center">
          <FontAwesomeIcon
            icon={byPrefixAndName.far["chevron-down"]}
            className={clsx(
              "transition-transform duration-300",
              isExpanded ? "rotate-180" : "",
            )}
          />
        </div>
      </button>
    </div>
  );
}

